import { ServicePost, ServiceGet} from './service'
import {
	app
} from './app';

export function getValidateCode(params) {
	return ServicePost({
		url: '/customer/send_validate_code',
		params: app.toMyJson(params)
	})
}
export function login(params) {
	return ServicePost({
		url: '/mall/small/h5/login',
		params: params
	})
}
export function regist(params) {
	return ServicePost({
		url: '/mall/small/h5/regist',
		params: params
	})
}
